<template>
    <div class="flex items-center text-xs leading-none font-extrabold tracking-tight">
        <span class="block">Generate Web Prices</span>
    </div>
</template>
